interface CriticalClaimDetailsProps {
  onDownload: () => void;
  formUrl: string;
}

export const CriticalClaimDetails: React.FC<CriticalClaimDetailsProps> = ({
  onDownload,
  formUrl,
}) => {
  return (
    <div className="mt-5 space-y-4">
      <p className="text-lg leading-7 text-[#2e313f]">
        If you’ve been diagnosed with a covered condition, we’re here to help
        you submit your claim quickly.
      </p>

      <div>
        <p className="font-semibold text-[#2e313f] text-2xl mb-2">
          Here's how:
        </p>
        <ol className="list-decimal pl-5 space-y-3 text-[#2e313f] text-lg marker:font-bold">
          <li>
            <span className="font-semibold">
              Download and complete the Critical Illness Claim Form:
            </span>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>
                <p>
                  <strong>Section I - Employee's Statement</strong> (your info +
                  diagnosis details)
                </p>
              </li>
              <li>
                <p>
                  <strong>Section II - Authorization</strong>(sign to allow
                  medical info for the claim)
                </p>
              </li>
              <li>
                <p>
                  <strong>Section II - Attending Physician’s Statement</strong>
                  (your provider completes)
                </p>
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Include medical documentation</strong> confirming the
              diagnosis (e.g., pathology report, discharge summary, specialist
              notes).
            </p>
          </li>
          <li>
            <p>
              <strong>Send your claim </strong> via email, fax, or mail (below).
            </p>
          </li>
          <li>
            <p>
              <strong>Need help? </strong> Call the claims line at (866)
              274-9887.
            </p>
          </li>
        </ol>
      </div>

      <hr className="w-[70%]" />

      <div className="space-y-1 text-[#2e313f] text-lg">
        <p className="font-semibold">Where do you send it?</p>
        <p>
          <strong>Email:</strong> EquitableClaims@yourbenefitexpert.com
        </p>
        <p>
          <strong>Fax:</strong> (866) 376-9480
        </p>
        <p className="font-semibold">Mail:</p>
        <p>Group Claims Department</p>
        <p>P.O. Box 9757</p>
        <p>Portland, ME 04104</p>
      </div>

      <button
        onClick={onDownload}
        className="w-full md:w-auto bg-primary text-white px-12 mt-2 py-4 rounded-full text-2xl max-sm:text-base uppercase"
      >
        DOWNLOAD CLAIM FORM
      </button>
    </div>
  );
};
